export default "__VITE_ASSET__OQ_gUEdG__"